import React, { useEffect, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { allAPiServicesCall } from "../../../services/apiServices";
import { getAuthConfig } from "../../../services/apiUtils";
import { useNavigate } from "react-router-dom";
import CommonLayout from "../../../layouts/CommonLayout";
import "./Feedback.css";

const Feedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const getFeedbacks = async () => {
    try {
      const response = await allAPiServicesCall.getFeedback(
        {},
        getAuthConfig(),
        navigate
      );
      setFeedbacks(response.data);
    } catch (error) {
      console.log("error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewMore = (feedback) => {
    setSelectedFeedback(feedback);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    getFeedbacks();
  }, []);

  return (
    <CommonLayout>
      <div className="page-wrapper">
        <div className="page-header">
          <h2>User Feedbacks</h2>
        </div>

        {loading ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        ) : feedbacks.length === 0 ? (
          <div className="empty-state">
            <p>No Feedbacks Found</p>
          </div>
        ) : (
          <>
            {/* Desktop Table View */}
            <div className="desktop-table-view">
              <div className="table-container">
                <Table className="modern-table" hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Subject</th>
                      <th>Message</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {feedbacks.map((feedback, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{feedback.name}</td>
                        <td>{feedback.email}</td>
                        <td>{feedback.subject}</td>
                        <td>
                          {feedback.message.length > 25
                            ? feedback.message.substring(0, 25) + "..."
                            : feedback.message}
                        </td>
                        <td>{new Date(feedback.createdAt).toLocaleDateString()}</td>
                        <td>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleViewMore(feedback)}
                          >
                            View More
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>

            {/* Mobile Card View */}
            <div className="mobile-card-view">
              {feedbacks.map((feedback, index) => (
                <div key={index} className="feedback-mobile-card">
                  <div className="feedback-mobile-header">
                    <div className="feedback-avatar">
                      {feedback.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="feedback-mobile-info">
                      <h4 className="feedback-name">{feedback.name}</h4>
                      <span className="feedback-date">
                        {new Date(feedback.createdAt).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                  <div className="feedback-mobile-body">
                    <div className="feedback-field">
                      <span className="field-label">Email</span>
                      <span className="field-value">{feedback.email}</span>
                    </div>
                    <div className="feedback-field">
                      <span className="field-label">Subject</span>
                      <span className="field-value">{feedback.subject}</span>
                    </div>
                    <div className="feedback-field">
                      <span className="field-label">Message</span>
                      <span className="field-value">
                        {feedback.message.length > 50
                          ? feedback.message.substring(0, 50) + "..."
                          : feedback.message}
                      </span>
                    </div>
                  </div>
                  <div className="feedback-mobile-actions">
                    <Button
                      variant="primary"
                      onClick={() => handleViewMore(feedback)}
                    >
                      View Details
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Modal for displaying full details */}
        {selectedFeedback && (
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Feedback Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                <strong>Name:</strong> {selectedFeedback.name}
              </p>
              <p>
                <strong>Email:</strong> {selectedFeedback.email}
              </p>
              <p>
                <strong>Subject:</strong> {selectedFeedback.subject}
              </p>
              <p>
                <strong>Message:</strong> {selectedFeedback.message}
              </p>
              <p>
                <strong>Date:</strong>{" "}
                {new Date(selectedFeedback.createdAt).toLocaleDateString()}
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </CommonLayout>
  );
};

export default Feedback;
